import _ from 'lodash'
import Nucc from 'shared_src/dictionaries/providers/Nucc'

import { phoneToFhir } from './lib/phone.js'
import { transform } from './mapper.js'

const notesEx = {
  url: 'http://narushealth.com/fhir/provider-network-organization-notes'
}

const PCP = {
  yes: {
    url: 'http://hl7.org/fhir/StructureDefinition/iso21090-preferred',
    valueInteger: 1
  },
  no: {
    url: 'http://hl7.org/fhir/StructureDefinition/iso21090-preferred',
    valueInteger: 0
  }
}

const mapping = [
  {
    fhir: [ 'resourceType' ],
    fhir_const: 'Organization'
  },
  {
    fhir: [ 'type', 'coding', 0 ],
    form: [ 'type' ],
    to_fhir: specialty => ({
      system: 'http://nucc.org/provider-taxonomy',
      code: specialty,
      display:
        specialty && specialty.length > 0
          ? _.filter(Nucc, n => n.code === specialty)[0]?.label ?? ''
          : ''
    }),
    to_form: coding => coding.code
  },
  {
    fhir: [ 'id' ],
    form: [ 'id' ]
  },
  {
    fhir: [ 'identifier' ],
    form: [ 'npi' ],
    to_fhir: v =>
      (v
        ? [
          {
            system: 'http://npiregistry.cms.hhs.gov/npi-id',
            value: v
          }
        ]
        : null),
    to_form: idnt => _.get(idnt, '[0].value')
  },
  {
    fhir: [ 'name' ],
    form: [ 'name' ]
  },
  {
    fhir: [ 'telecom', { system: 'phone' }, 'value' ],
    form: [ 'phone' ],
    to_fhir: v => phoneToFhir(v)
  },
  {
    fhir: [ 'telecom', { system: 'phone' }, 'use' ],
    form: [ 'phoneType' ]
  },
  {
    fhir: [ 'telecom', { system: 'fax' }, 'value' ],
    form: [ 'fax' ],
    to_fhir: v => phoneToFhir(v)
  },
  {
    fhir: [ 'address', { use: 'work' }, 'line', 0 ],
    form: [ 'address1' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'line', 1 ],
    form: [ 'address2' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'city' ],
    form: [ 'city' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'postalCode' ],
    form: [ 'zip' ]
  },
  {
    fhir: [ 'address', { use: 'work' }, 'state' ],
    form: [ 'state' ]
  },
  {
    fhir: [ 'telecom', { system: 'email' }, 'value' ],
    form: [ 'email' ]
  },
  {
    fhir: [ '_pcp' ],
    form: [ 'preferred' ],
    to_fhir: pcp => pcp && PCP[pcp],
    to_form: pcp =>
      pcp &&
      ((pcp.valueInteger === 1 && 'yes') || (pcp.valueInteger === 0 && 'no'))
  },
  {
    fhir: [ 'extension', notesEx, 'valueString' ],
    form: [ 'notes' ]
  }
]

export const mapOrganization = (patientId, form) =>
  transform(form, mapping, [ 'form', 'fhir' ])

export const unmapOrganization = data =>
  transform(data, mapping, [ 'fhir', 'form' ])
